module.exports = __webpack_public_path__ + "img/189.6f759336.svg";